var appendPrependMenuMobile = function() {
        var headerLanguageCurrencyPC = $('.wrapper-language-currency'),
            headerLanguageCurrencyMB = $('.nav-currency-language'),
            headerSidebarLanguageCurrency = $('.halo-language-currency-sidebar .halo-sidebar-wrapper');
        if (window.innerWidth < 1025) {
            headerLanguageCurrencyPC.appendTo(headerLanguageCurrencyMB);
        } else {
            headerLanguageCurrencyPC.appendTo(headerSidebarLanguageCurrency);
        };
    };
    $(document).ready(function() {
        appendPrependMenuMobile();
    });
    $(window).on('resize', function () {
        appendPrependMenuMobile();
    })